import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as Pipes from './pipes-index';;
import { HoursMinutesPipe } from './hours-minutes.pipe'

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        Pipes.SdAbsoluteValuePipe,
        Pipes.SdElapsedTimePipe,
        Pipes.SdNullPipe,
        Pipes.SdPercentagePipe,
        Pipes.SdPhonePipe,
        Pipes.HoursMinutesPipe,
        Pipes.SafeHtmlPipe,
        Pipes.SafeSvgPipe
    ],
    exports: [
        Pipes.SdAbsoluteValuePipe,
        Pipes.SdElapsedTimePipe,
        Pipes.SdNullPipe,
        Pipes.SdPercentagePipe,
        Pipes.SdPhonePipe,
        Pipes.HoursMinutesPipe,
        Pipes.SafeHtmlPipe,
        Pipes.SafeSvgPipe
    ]
})
export class SdPipesModule { }

export { SdAbsoluteValuePipe } from './pipes-index';
export { SdElapsedTimePipe } from './pipes-index';
export { SdNullPipe } from './pipes-index';
export { SdPercentagePipe } from './pipes-index';
export { SdPhonePipe } from './pipes-index';
export { HoursMinutesPipe } from './pipes-index';
export { SafeHtmlPipe } from './pipes-index';
export { SafeSvgPipe } from './pipes-index';
